export default "__VITE_ASSET__BKDmSnLV__"